import type { BlockRecord } from '@/lib/blocks/types';

export type EnsureSidebarChildren = (parentId: string) => void | Promise<BlockRecord[]>;

export function pageHasChildPagesInTree(
  blockId: string,
  blockType: string,
  childrenByParent: Record<string, BlockRecord[]>,
): boolean {
  if (blockType !== 'page') {
    return false;
  }
  const childList = childrenByParent[blockId];
  return childList?.some((row) => row.type === 'page' || row.type === 'database') ?? false;
}

export function prefetchSidebarPageChildLists(
  pages: readonly { id: string; type: string }[],
  childrenByParent: Record<string, BlockRecord[]>,
  ensureChildren: EnsureSidebarChildren,
): void {
  for (const page of pages) {
    if (page.type === 'page' && childrenByParent[page.id] === undefined) {
      void ensureChildren(page.id);
    }
  }
}
